import { z } from 'zod';

// Direct snake_case validation - matches API exactly!
export const labOrderSchema = z.object({
  patient_id: z.string().min(1, 'Patient is required'),
  lab_tests: z.array(z.string()).min(1, 'At least one test is required'),
  icd_10_codes: z
    .array(z.string())
    .nullable()
    .optional()
    .refine(val => val && val.length > 0, { message: 'At least one ICD-10 code is required' }),
  special_instructions: z.string().nullable().optional(),
  sign_with_name: z.boolean().optional(),
});
